export const selectCanEditTraining = state => ['ADMIN', 'MANAGER'].includes(String(state.auth?.user?.role?.name || state.auth?.user?.role || '').toUpperCase());
export function filterTrainingStaff(rows, { search = '', status = '', category = '' }) {
  const term = search.trim().toLowerCase();
  return rows.filter(row => (!term || (row.fullName + ' ' + row.employeeId).toLowerCase().includes(term)) &&
    (!status || row.overallStatus === status) && (!category || row.categories.some(cell => String(cell.categoryId) === String(category) && cell.recordId)));
}
